import React, { useContext, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getIn } from 'formik'

import FacebookMediaUpload from '../../../../../../../../ReusableFormFields/FacebookMediaUpload'
import Field from '../../../../../../../../../components/Form/Field'

import { concat, keys } from '../../../../../../../../../helpers/common'
import { formatOptionsList } from '../../../../../../../../../features/formatters'
import useLineItemDetails from '../../../../hooks/useLineItemDetails'

import { choicesCTAByGoalSelector } from '../../../../../../../../../modules/selectors/choices'

import { AdFacebookCreateContext } from '../../../../../../../formsContexts/AdFacebookCreateFormContextProvider'

import {
  CALL_TO_ACTION,
  CLICK_THROUGH_LINK,
  STORIES_ITEM_MEDIA_FILE_ERROR,
  STORIES_ITEMS
} from '../../../../../../fields'

import { FILE_URL } from '../../../../../../../../ReusableFormFields/AdFileUpload/fields'

const recommendedSize = '1080 x 1920 px'

const StoriesFormFields = ({ formik, index, isItemActive, showError, isStepFieldsValid }) => {
  const { t } = useTranslation()

  const { values, errors, touched, setFieldTouched } = formik

  const itemPath = `${STORIES_ITEMS}[${index}]`

  const { preselectedValues, campaignObjective } = useContext(AdFacebookCreateContext)

  const actionsList = useSelector(choicesCTAByGoalSelector(campaignObjective))

  const item = getIn(values, itemPath)
  const itemErrors = getIn(errors, itemPath)
  const itemTouched = getIn(touched, itemPath)
  const isValid = itemErrors && itemTouched && isStepFieldsValid(itemErrors, keys(itemTouched))
  const showFileUrlError = !isValid && itemTouched?.[FILE_URL]
  const mediaUrlError = showFileUrlError && itemErrors?.[FILE_URL]
  const mediaFileError = getIn(values, `${itemPath}.${STORIES_ITEM_MEDIA_FILE_ERROR}`)

  const { isVideoViews } = useLineItemDetails()

  const formattedActionsList = useMemo(() => {
    return formatOptionsList({
      list: actionsList,
      labelName: 'label',
      valueName: 'name'
    })
  }, [actionsList])

  useEffect(() => {
    if (showError) {
      setFieldTouched(`${STORIES_ITEMS}[${index}].${FILE_URL}`, true)
      setFieldTouched(`${STORIES_ITEMS}[${index}].${CLICK_THROUGH_LINK}`, true)
    }
  }, [showError, setFieldTouched, index, values, item])

  return (
    <>
      <FacebookMediaUpload
        formik={formik}
        item={item}
        itemPath={itemPath}
        isItemActive={isItemActive}
        mediaFileErrorField={concat(itemPath, '.', STORIES_ITEM_MEDIA_FILE_ERROR)}
        mediaFileError={mediaFileError}
        mediaUrlError={mediaUrlError}
        recommendedSize={recommendedSize}
        allowImage={!isVideoViews}
      />
      {!preselectedValues[CALL_TO_ACTION] && (
        <Field
          placeholder={t('CALL-TO-ACTION')}
          formik={formik}
          name={`${itemPath}.${CALL_TO_ACTION}`}
          options={formattedActionsList}
        />
      )}
      {!preselectedValues[CLICK_THROUGH_LINK] && (
        <Field
          formik={formik}
          name={`${itemPath}.${CLICK_THROUGH_LINK}`}
          placeholder={t('CLICK THROUGH LINK')}
          autoComplete="off"
        />
      )}
    </>
  )
}

export default StoriesFormFields
